/** Clothing presets carry garment dyes while preserving the wearer's identity. */
import { DEFAULT_STYLE, STYLE_PARTS, clampStyleToUnlocks, type CharacterStyle } from "@hyperlight/shared";

export function wearOutfit(
  appearance: CharacterStyle, outfit: CharacterStyle, ownedTokens: readonly string[],
): CharacterStyle {
  const next = { ...appearance, suit: outfit.suit, accent: outfit.accent, shirtColor: outfit.shirtColor ?? DEFAULT_STYLE.shirtColor, pantsColor: outfit.pantsColor ?? DEFAULT_STYLE.pantsColor };
  for (const part of STYLE_PARTS) next[part] = outfit[part];
  next.hiddenGear = STYLE_PARTS.filter(part => outfit[part] === "none");
  return clampStyleToUnlocks(next, new Set(ownedTokens));
}
